/**
 * Chave de acesso de NF-e (modelo 55) / NFC-e (modelo 65): 44 dígitos.
 * Layout: cUF(2) AAMM(4) CNPJ(14) modelo(2) série(3) número(9) tpEmis(1) cNF(8) DV(1)
 * Espelha App\Services\Fiscal\InvoiceKey do backend.
 */
export const INVOICE_KEY_LENGTH = 44;

export const onlyDigits = value => String(value || '').replace(/\D+/g, '');

const checkDigit = digits => {
  let sum = 0;
  let weight = 2;

  for (let i = digits.length - 1; i >= 0; i -= 1) {
    sum += Number(digits[i]) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }

  const rest = sum % 11;

  return rest < 2 ? 0 : 11 - rest;
};

export const isValidInvoiceKey = value => {
  const key = onlyDigits(value);

  if (key.length !== INVOICE_KEY_LENGTH) return false;
  if (!['55', '65'].includes(key.slice(20, 22))) return false;

  return checkDigit(key.slice(0, 43)) === Number(key[43]);
};

export const parseInvoiceKey = value => {
  const key = onlyDigits(value);

  return {
    key,
    model: key.slice(20, 22),
    emitterCnpj: key.slice(6, 20),
    series: String(Number(key.slice(22, 25))),
    number: String(Number(key.slice(25, 34))),
  };
};

/**
 * Extrai a chave de um texto: XML da nota (Id="NFe..." ou <chNFe>),
 * URL do QR Code da NFC-e ou código de barras da DANFE.
 */
export const extractInvoiceKey = text => {
  const source = String(text || '');

  const fromXml =
    source.match(/NFe(\d{44})/) || source.match(/<chNFe>(\d{44})<\/chNFe>/);
  if (fromXml) return fromXml[1];

  const plain = source.match(/\d{44}/);

  return plain ? plain[0] : null;
};

/** 4226 1198 6873 0600 ... */
export const formatInvoiceKey = value =>
  onlyDigits(value)
    .replace(/(\d{4})(?=\d)/g, '$1 ')
    .trim();
